// extracted by mini-css-extract-plugin
module.exports = {"link":"link_link__hUKht","primary":"link_primary__narai","center":"link_center__JDT_X","allWidth":"link_allWidth__i21Es"};